import React from "react";
import "../assets/css/popular.card.css";
import { PopularFeaturedCard } from "./popular.featured.card";
export function Popular({ data }) {
  return <PopularFeaturedCard type="Popular" data={data} />;
}
